import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import loggerIntegrationApi from '../../../services/apiServices/loggerIntegrationApi';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../services/redux/loadingSlice';
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';

const LoggerIntegrationPage = () => {
    const { code } = useParams();
    const dispatch = useDispatch();
    const [log, setLog] = useState(null);

    useEffect(() => {
        const fetchLog = async () => {
            dispatch(setLoading(true));
            try {
                const result = await loggerIntegrationApi.getLoggerIntegrationById(code);
                setLog(result);
            } catch (error) {
                toast.error('Erro ao buscar log.');
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchLog();
    }, [code, dispatch]);

    if (!log) return <div className="log-container">Carregando...</div>;

    return (
        <div className="container-admin-page">
            <h1>Detalhes da Integração</h1>

            <div className="box space-double-bottom">
                <div className="info-group">
                    <p><strong>Id:</strong> {log.Id}</p>
                    <p><strong>Pedido:</strong> {log.OrderId ?? 'Não vinculado'}</p>
                    <p><strong>Data de Criação:</strong> {putDateOnPattern(log.Created)}</p>
                    <p><strong>Última Atualização:</strong> {putDateOnPattern(log.Updated)}</p>
                </div>
            </div>

            <div className="box space-double-bottom">
                <h2>Conteúdo</h2>
                <pre className="log-pre">
                    {log.TextLog}
                </pre>
            </div>
        </div>
    );
};

export default LoggerIntegrationPage;
